import styles from "./Sidebar.module.css";
import TheIcon from "../../../../Shared/Components/UI/TheIcon/TheIcon";
import { useState, useContext } from "react";
import { AdminContext } from "../../../../Context/Admin.Context";
import { AuthContext } from "../../../../Context/Auth.Context";
import { RoutingContext } from "../../../../Context/Routing.Context";
import { AnimatePresence, motion } from "framer-motion";
import MenuRowToggleBox from "../../../../Shared/Components/UI/NavigationElements/MenuRowToggleBox";
import { jwtDecode } from "jwt-decode";

const SideBar = () => {
  const [showManageProductLinks, setShowManageProductLinks] = useState(false);
  const [showManageUserLinks, setShowManageUserLinks] = useState(false);
  const [showAdministratorLinks, setShowAdministratorLinks] = useState(false);
  const [showAnalyticsLinks, setShowAnalyticsLinks] = useState(false);
  const [showFeatureDefinitionLinks, setShowFeatureDefinitionLinks] = useState(false);
  const [showSidebar, setShowSidebar] = useState(false);

  const { token } = useContext(AuthContext);
  const decodedToken = token ? jwtDecode(token) : null;
  const { setIsRoutingState } = useContext(RoutingContext);
  const { setIsActiveSection, isActiveSection } = useContext(AdminContext);

  const handleSectionClick = (sectionNumber) => {
    setShowSidebar(false);
    setIsActiveSection(sectionNumber);
    setIsRoutingState((prevState) => ({
      ...prevState,
      isNavLinkedClicked: true,
    }));
  };

  return (
    <div className={styles.sidebarWrapper}>
      <div className={styles.tabColumn}>
        {showSidebar ? (
          <div  className={styles.tabCloseIcon}onClick={() => setShowSidebar(false)}>
            <TheIcon   name="close" />
          </div>
        ) : (
          <div  className={styles.tabOpenIcon}onClick={() => setShowSidebar(true)}>
            <TheIcon name="rxdash" />
          </div>
        )}
      </div>

      <AnimatePresence>
        {showSidebar && (
          <motion.div
            className={styles.sidebarMenuWrapper}
            initial={{ opacity: 0, x: 50 }}
            animate={{
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.3,
                ease: [0.75, 0, 0, 1],
              },
            }}
            exit={{
              opacity: 0,
              x: 50,
              transition: {
                duration: 0.3,
                ease: [0.75, 0, 0, 1],
              },
            }}
          >
            <div className={styles.menuRow} id={styles.menuRowTopBox}>
              <div
                onClick={() => handleSectionClick(1)}
                className={styles.rowHeaderBox}
              >
                <TheIcon name="rxdash" />
                <p className={styles.rowHeaderTitle}>Dashboard</p>
              </div>
            </div>

            {token && decodedToken?.role === "superAdmin" && (
              <div className={styles.menuRow}>
                <span className={styles.menuHeaderShade}>
                  <MenuRowToggleBox
                    styleName="pillMenuRowToggleBoxContainer"
                    themeIcon="true"
                    iconName="admin"
                    onClick={() =>
                      setShowAdministratorLinks((prevState) => !prevState)
                    }
                    clickText="Admin Tools"
                    condition={showAdministratorLinks}
                  />
                </span>

                {showAdministratorLinks && (
                  <div className={styles.rowDropdownBox}>
                    <p onClick={() => handleSectionClick(8)}>Create Admin</p>
                    <p onClick={() => handleSectionClick(6)}>All Admins</p>
                  </div>
                )}
              </div>
            )}

            <div className={styles.menuRow}>
              <MenuRowToggleBox
                styleName="pillMenuRowToggleBoxContainer"
                onClick={() =>
                  setShowManageProductLinks((prevState) => !prevState)
                }
                clickText="Product Tools"
                condition={showManageProductLinks}
                themeIcon="true"
                iconName="inventory"
              />

              {showManageProductLinks && (
                <div className={styles.rowDropdownBox}>
                  <p
                    className={isActiveSection === 3 ? styles.active : undefined}
                    onClick={() => handleSectionClick(3)}
                  >
                    Add Product
                  </p>
                  <p
                    className={isActiveSection === 2 ? styles.active : undefined}
                    onClick={() => handleSectionClick(2)}
                  >
                    All Products
                  </p>
                </div>
              )}
            </div>

            <div className={styles.menuRow}>
              <MenuRowToggleBox
                styleName="pillMenuRowToggleBoxContainer"
                onClick={() =>
                  setShowFeatureDefinitionLinks((prevState) => !prevState)
                }
                clickText="Definitions"
                condition={showFeatureDefinitionLinks}
                themeIcon="true"
              iconName="tooltip"
              />

              {showFeatureDefinitionLinks && (
                <div className={styles.rowDropdownBox}>
                  <p
                    className={isActiveSection === 12 ? styles.active : undefined}
                    onClick={() => handleSectionClick(12)}
                  >
                    All Definitions
                  </p>

                  {/* Add later after form is built */}
                  
                  <p
                    className={isActiveSection === 13 ? styles.active : undefined}
                    onClick={() => handleSectionClick(13)}
                  >
                    Add Definition
                  </p> 
                 
                </div>
              )}
            </div>

            <div className={styles.menuRow}>
              <MenuRowToggleBox
                styleName="pillMenuRowToggleBoxContainer"
                onClick={() =>
                  setShowManageUserLinks((prevState) => !prevState)
                }
                clickText="User Tools"
                condition={showManageUserLinks}
                themeIcon="true"
                iconName="users"
              />

              {showManageUserLinks && (
                <div className={styles.rowDropdownBox}>
                  <p
                    className={isActiveSection === 5 ? styles.active : undefined}
                    onClick={() => handleSectionClick(5)}
                  >
                    All Users
                  </p>
                </div>
              )}
            </div>

            <div className={styles.menuRow}>
              <MenuRowToggleBox
                styleName="pillMenuRowToggleBoxContainer"
                onClick={() =>
                  setShowAnalyticsLinks((prevState) => !prevState)
                }
                clickText="Analytics"
                condition={showAnalyticsLinks}
                themeIcon="true"
                iconName="dashboard"
              />

              {showAnalyticsLinks && (
                <div className={styles.rowDropdownBox}>
                  <p
                    className={isActiveSection === 10 ? styles.active : undefined}
                    onClick={() => handleSectionClick(10)}
                  >
                    Website Activity
                  </p>
                </div>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default SideBar;